import React, { useEffect, useState } from 'react';
import { InputTypes, TaskInput } from 'interfaces/ITask.interface';
import { useTranslation } from 'react-i18next';
import Button from '@salesforce/design-system-react/components/button'; 
import Modal from '@salesforce/design-system-react/components/modal'; 
import Icon from '@salesforce/design-system-react/components/icon';
import { ProfileInput } from './profile';
import { CheckboxInput } from './checkbox-input';

export interface CQInputProps {
    taskInput: TaskInput;
    onInputChange: (attribute: string, newValue: any) => void;
}

export function CQInput({taskInput, onInputChange }: CQInputProps) {
    const [value, setValue] = useState<any>(null);
    const {t, i18n} = useTranslation();
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        switch(taskInput.type) {
            case InputTypes.Profiles: setValue( taskInput.default || []); break;
            case InputTypes.Checkbox: setValue(taskInput.default || true); break;
            default: setValue(taskInput.default);
        }
    }, [taskInput])

    function getDisplayValue() {
        if(value && value instanceof Array) {
            return value.map((val : string) => {
                let translationKey = `task_input_${taskInput.name.toLowerCase()}_${val.toLowerCase()}`;
                return i18n.exists(translationKey) ? t(translationKey) : value;
            }).join(', ');
        }

        if(taskInput.type === InputTypes.Checkbox && taskInput.name === "Prefer_Push_Upgrade") {
            const translationKey = value ? `task_input_${taskInput.name.toLowerCase()}_true` : `task_input_${taskInput.name.toLowerCase()}_false`;
            return i18n.exists(translationKey) ? t(translationKey) : (value ? 'True' : 'False');
        }

        return value;
    }

    function getInputTemplate() {
        switch(taskInput.type) {
            case InputTypes.Profiles: return <ProfileInput selected={value} onChange={(selected) => {
                onInputChange(taskInput.name, selected);
                setValue(selected);
            }}></ProfileInput>
            case InputTypes.Checkbox: return <CheckboxInput 
                name={taskInput.name}
                checked={value}
                onChange={(checked) => {
                    onInputChange(taskInput.name, checked);
                    setValue(checked);
                }}
            />
            default: return <input className="slds-input" type="text" value={value} onChange={(evt) => {
                onInputChange(taskInput.name, evt.currentTarget.value);
                setValue(evt.currentTarget.value);
            }}></input>;
        }
    }

    return <>
        <div className="slds-grid">
            <div className="slds-col slds-size_11-of-12">
                {getDisplayValue()}
            </div>
            <div className="slds-col slds-size_1-of-12">
                <Button iconName="edit" iconCategory="utility" iconSize="small" iconVariant="container"  variant="icon" onClick={() => {
                    setShowModal(true);
                }}></Button>
            </div>
        </div>
        <Modal
						isOpen={showModal}
						footer={[
							<Button label="Cancel" onClick={() => {setShowModal(false); }} />,
							<Button label="Save" variant="brand" onClick={() => {setShowModal(false); }} />,
						]}
						onRequestClose={() => {setShowModal(false); }}
						heading={t("task_input_" + taskInput.name)}
					><div className="slds-p-around_medium">{getInputTemplate()}</div></Modal>
    </>
}